class Slider {
    constructor(slider) {

      this.container = slider;
      this.controllers = [...this.container.querySelectorAll('.js-controller')];
      this.list = this.container.querySelector('.js-items');
      this.elements = [...this.list.querySelectorAll('li')];
      this.index = 0;
      this.step = this.elements[0].offsetWidth;
      this.listen();
    } 
    
    listen(){
      this.controllers.forEach(control => {
        control.addEventListener('click', () => {
          control.classList.contains('prev') ? this.prev() : this.next();
        })
      })
    }
  
    prev() {
      this.index = this.index - 1 >= 0 ? this.index - 1 : this.elements.length - 1;
      this.slide();
    }
  
    next() {
      this.index = (this.index + 1) % this.elements.length;
      this.slide();
    }
  
    slide(){
      this.list.style.transform = `translateX(-${this.index * this.step}px)`;
      this.list.style.msTransform = `translateX(-${this.index * this.step}px)`;
      this.list.style.webkitTransform = `translateX(-${this.index * this.step}px)`;
    }
  }
  
  window.addEventListener("DOMContentLoaded", () => {
    let sliders = [...document.getElementsByClassName('js-slider')];
    sliders.forEach(slider =>  new Slider(slider));  
  
  });